import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import {__} from "~/ts/library/Translate";
import OperatorApplicationDialogTextareaButton
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaButton.vue";
import useTextareaComponent from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";
import {computed} from "vue";
import OperatorApplicationPlatformFactory from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import {showMessage} from "~/ts/vuePlugins/ShowMessagePlugin";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "VoiceMessageButton"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let {isCopilotAvailableByTarif, startVoiceTranscribe} = useTextareaComponent();


let isAudioAvailable = computed(() => {
    return OperatorApplicationPlatformFactory.isNative || window.location.protocol == "https:";
});


async function startRecord() {
    if (!isCopilotAvailableByTarif.value) {
        showMessage({
            message: "Пакет \"AI-ассистент\" недоступен в текущих параметрах лицензии",
            title: __("Ошибка"),
            type: "error"
        })
    } else {
        startVoiceTranscribe();
    }
}

return (_ctx: any,_cache: any) => {
  return (_unref(isAudioAvailable))
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createVNode(OperatorApplicationDialogTextareaButton, {
          icon: "waveform-lines",
          tooltip: _unref(__)('Текст под диктовку'),
          onClick: startRecord
        }, null, 8, ["tooltip"])
      ]))
    : _createCommentVNode("", true)
}
}

})